// extracted by mini-css-extract-plugin
export var toutTextImageContentLarge = "toutText-module--toutTextImageContentLarge--qSUnp";
export var toutTextImageInverted = "toutText-module--toutTextImageInverted--F0ePB";